import MerchantApiV2 from 'api/v2/admins/merchants-api-v2'
import { SelectSearchField } from 'components'
import React, { useState } from 'react'
import MerchantBadge from 'domains/merchant/atoms/merchant-badge'
import PropTypes from 'prop-types'

const propTypes = {
  name      : PropTypes.string,
  label     : PropTypes.string,
  required  : PropTypes.bool,
  valueType : PropTypes.string
}

const defaultProps = {
  valueType: 'object'
}

/**
 * Search field to select merchant by merchant code.
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 */
const MerchantSelectSearchField = ({
  name,
  label,
  required,
  valueType,
  ...props
}) => {
  const [ searchMerchants, setSearchMerchants ] = useState([])
  const [ isSearchLoading, setSearchLoading ]   = useState(false)
  var merchantSearchTimeout                     = null
  // search merchants by similar code
  const getMerchants = async (code) => {
    setSearchLoading(true)

    const additionalFilters = {
      code: code
    }

    await MerchantApiV2.get({ additionalFilters: additionalFilters })
      .then((response) => {
        setSearchMerchants(response.data.merchants)
        setSearchLoading(false)
      })
      .catch((error) => {
        alert(error.message)
      })
  }

  // The presentation of option label when dropdown is open
  const getOptionLabel = (option) => (
    <>
      <span className='mr-3'>{ option.name }</span>
      <span className='mr-3'>{ '-' }</span>
      <span className='mr-3'>{ option.code }</span>
      <span className='mr-3'>{ '-' }</span>
      <span className='mr-3'>{ <MerchantBadge merchant_type={ option.merchant_type } /> }</span>
    </>
  )

  // use to compare with Formik's value
  const getOptionValue = (option) => valueType == 'number' ? option.id : option

  // handler to search merchants
  const handleSelectSearchOnChange = (event) => {
    const searchText = event.target.value
    if (merchantSearchTimeout) clearTimeout(merchantSearchTimeout)
    merchantSearchTimeout = setTimeout(() => {
      getMerchants(searchText)
    }, 700)
  }

  return (
    <>
      <SelectSearchField
        type='text'
        name={ name }
        label={ label }
        placeholder='Search with Merchant Code'
        dataList={ searchMerchants }
        onSearchChange={ handleSelectSearchOnChange }
        getOptionLabel={ getOptionLabel }
        getOptionValue={ getOptionValue }
        isLoading={ isSearchLoading }
        required={ required }
        { ...props }
      />
    </>
  )
}

MerchantSelectSearchField.propTypes    = propTypes
MerchantSelectSearchField.defaultProps = defaultProps

export default MerchantSelectSearchField
